// import ModalForm from "./Form";
import BookingForm from "./BookingForm";
import { BOOKING, DATATABLE_EXPORT } from "../../../../../../Config/ApiUrl";
import * as actions from "../../../../../../Config/ApiUrl";

export const BookingSchema = {
	components: { BookingForm },

	data() {
		return {
			DATATABLE_EXPORT,
			isAddEditModalActive: false,
			deleteConfirmationModalActive: false,
			deleteLoader: false,
			selectedUrl: this.ENDPOINT,
			tableId: "booking-table",
			rowData: {},
			formId: "booking-form",
			tableColumns: [
				{
					title: "Appointment Type",
					type: "custom-html",
					key: "placement_type",
					modifier: (value) => {
						if(value.id == 1){
							return 'Class Trial';
						}else if(value.id == 2){
							return 'Placement Test';
						}else if(value.id == 3){
							return 'Direct';
						}
					},
				},
				{
					title: "Location Test",
					type: "text",
					key: "location_test",
				},
				{
					title: "Center",
					type: "custom-html",
					key: "center",
					modifier: (value) => {
						return value?.name ?? ''
					},
				},
				{
					title: "Book Date",
					type: "text",
					key: "book_date",
				},
				{
					title: "Book Time",
					type: "custom-html",
					key: "book_time",
                    modifier: (value) => {
                        return value ? value.slice(0, -3) : '';
                    }
				},
				// {
				// 	title: "Sub Status",
				// 	type: "custom-html",
				// 	key: "status",
				// 	isVisible: true,
				// 	modifier: (value) => {
				// 		if (value && value.status) {
				// 			return `<span class="badge badge-sm badge-pill badge-${value.color_status ?? 'primary'}">${this.$t(
				// 				value.status
				// 			)}</span>`;
				// 		}
				// 	},
				// },
				{
					title: "Reason",
					type: "text",
					key: "reason",
				},
			],
			ENDPOINT: BOOKING + "?clc_id_number=" + this.value.clc_id_number,
			actionObj: {
				title: this.$t("action"),
				type: "action",
			},
			options: {
				name: "BookingTable",
				url: BOOKING + "?clc_id_number=" + this.value.clc_id_number,
				showHeader: true,
				enableHighlights: true,
				// enableRowSelect: true,
				enableSaveFilter: true,
				columns: [],
				actions: [
					{
						title: this.$t("edit"),
						icon: "edit",
						type: "none",
						component: "app-add-modal",
						modalId: "booking-form",
					},
					{
						title: this.$t("delete"),
						icon: "trash",
						type: "none",
						component: "app-confirmation-modal",
						modalId: "demo-delete",
					},
				],
				filters: [],
				showFilter: true,
				showSearch: true,
				showCount: true,
				showClearFilter: true,
				paginationType: "pagination",
				responsive: true,
				rowLimit: 10,
				showAction: true,
				orderBy: "desc",
				actionType: "default",
			},
		};
	},
	methods: {},
};
